<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <h2>Calendario</h2>
        <v-divider></v-divider>
      </v-col>
      <v-col cols="6" style="margin-bottom: 0.1vh" v-if="mode==PlannerMode.PlannerViewer">
        <h3>Velocità scroller</h3>
        <v-slider
          v-model="settings.scrollerSpeed"
          step="1"
          min="0"
          max="2"
          thumb-label
          ticks
        ></v-slider>
      </v-col>
      <v-col cols="6" style="margin-bottom: 0.1vh"> </v-col>

      <v-col cols="12" style="margin-bottom: 1vh">
        <h3>Giorni da visualizzare:</h3>
        <v-row>
          <v-col cols="12">
            <v-slide-group
              v-model="settings.daysToShow"
              multiple
              show-arrows
              @change="visibleDaysChanged"
              @select="visibleDaysSelect"
            >
              <v-slide-item
                v-for="day in days"
                :key="day.id"
                :id="day.id"
                :value="day.id"
                v-slot="{ active, toggle }"
              >
                <v-btn
                  class="mx-2"
                  :input-value="active"
                  active-class="primary"
                  depressed
                  rounded
                  @click="toggle"
                >
                  {{ day.text }}
                </v-btn>
              </v-slide-item>
            </v-slide-group>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="6" style="margin-bottom: 0.1vh">
        <h3>Numero massimo di giorni da visualizzare</h3>
        <v-slider
          step="1"
          min="1"
          :disabled="settings.fitVisibleDays"
          v-model="settings.maxDaysToShow"
          max="31"
          thumb-label
          ticks
        ></v-slider>
      </v-col>

      <v-col cols="6" style="margin-bottom: 0.1vh">
        <!-- <h3>Numero massimo di giorni da visualizzare</h3> -->
        <v-checkbox
          label="Adatta automaticamente"
          v-model="settings.fitVisibleDays"
        ></v-checkbox>
      </v-col>

      <v-col cols="6" style="margin-bottom: 0.1vh">
        <!-- <h3>Numero massimo di giorni da visualizzare</h3> -->
        <v-checkbox
          label="Inizia calendario da giorno corrente"
          v-model="settings.startFromToday"
        ></v-checkbox>
      </v-col>

      <v-col cols="12"  v-if="mode==PlannerMode.Planner">
        <h2>Motivi assenze</h2>
        <v-divider></v-divider>
      </v-col>
      <v-col cols="6"  v-if="mode==PlannerMode.Planner">
        <h3>Operatori</h3>
        <v-combobox
          v-model="settings.operatorsAbsenceReasons"
          label="Digita il motivo e poi premi invio per aggiungerlo all'elenco"
          multiple
        >
          <template v-slot:selection="{ attrs, item, select, selected }">
            <v-chip
              v-bind="attrs"
              :input-value="selected"
              close
              close-icon="mdi-delete"
              @click="select"
              @click:close="removeOperatorsAbsenceReason(item)"
            >
              <strong>{{ item }}</strong>
            </v-chip>
          </template>
        </v-combobox>
      </v-col>
      <v-col cols="6" v-if="mode==PlannerMode.Planner">
        <h3>Mezzi</h3>

        <v-combobox
          v-model="settings.vehiclesAbsenceReasons"
          label="Digita il motivo e poi premi invio per aggiungerlo all'elenco"
          multiple
        >
          <template v-slot:selection="{ attrs, item, select, selected }">
            <v-chip
              v-bind="attrs"
              :input-value="selected"
              close
              close-icon="mdi-delete"
              @click="select"
              @click:close="removeVehiclesAbsenceReason(item)"
            >
              <strong>{{ item }}</strong>
            </v-chip>
          </template>
        </v-combobox>
      </v-col>
      <v-col cols="6" v-if="mode==PlannerMode.Planner">
        <h3>Attrezzature</h3>
        <v-combobox
          v-model="settings.equipmentsAbsenceReasons"
          label="Digita il motivo e poi premi invio per aggiungerlo all'elenco"
          multiple
        >
          <template v-slot:selection="{ attrs, item, select, selected }">
            <v-chip
              v-bind="attrs"
              :input-value="selected"
              close
              close-icon="mdi-delete"
              @click="select"
              @click:close="removeEquipmentAbsenceReason(item)"
            >
              <strong>{{ item }}</strong>
            </v-chip>
          </template>
        </v-combobox>
      </v-col>
      <v-col cols="12" v-if="mode==PlannerMode.Planner">
        <h2>Nuovo evento</h2>
        <v-divider></v-divider>
      </v-col>
      <v-col cols="12" style="margin-bottom: 1vh" v-if="mode==PlannerMode.Planner">
        <h3>Tab da visualizzare:</h3>
        <v-row>
          <v-col cols="12">
            <v-slide-group
              v-model="settings.tabsToShow"
              multiple
              show-arrows
              @change="visibleDaysChanged"
              @select="visibleDaysSelect"
            >
              <v-slide-item
                v-for="tab in createEventTabs"
                :key="tab.id"
                :id="tab.id"
                :value="tab.id"
                v-slot="{ active, toggle }"
              >
                <v-btn
                  class="mx-2"
                  :input-value="active"
                  active-class="primary"
                  :disabled="tab.mandatory"
                  depressed
                  @click="toggle"
                >
                  {{ tab.text }}
                </v-btn>
              </v-slide-item>
            </v-slide-group>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>
<script> 
 import PlannerMode from '../../../settings/PlannerMode' 
export default  {

  props: {
    plannerSettings: { type: Object, default: null },
    mode:{type:PlannerMode}
  },
  watch: {
    plannerSettings(old, newV) {
      this.loadSettings(newV);
    },
  },
  created() {
    this.loadSettings(this.plannerSettings);
    // this.loadSettings();
    // this.settings.planner.daysToShow = [0,1,2,3,4,5];
  },

  computed: {},
  methods: {
    loadSettings(settings) {
      this.settings = settings;
      if (!this.settings.tabsToShow)
        this.settings.tabsToShow = this.createEventTabs
          .filter((e) => e.mandatory)
          .map((e) => e.id);
    },
    removeEquipmentAbsenceReason(item) {
      this.settings.equipmentsAbsenceReasons =
        this.settings.equipmentsAbsenceReasons.filter((r) => r != item);
    },
    removeOperatorsAbsenceReason(item) {
      this.settings.operatorsAbsenceReasons =
        this.settings.operatorsAbsenceReasons.filter((r) => r != item);
    },
    removeVehiclesAbsenceReason(item) {
      this.settings.vehiclesAbsenceReasons =
        this.settings.vehiclesAbsenceReasons.filter((r) => r != item);
    },
    SetSettings(plannerSettings) {
      this.settings = plannerSettings;
    },
    GetSettings() {
      //Quando seleziono i giorni, lui mi salva la posizione nell'array e non l'id
      // let tmpDaysToShow = [];
      // for (let i = 0; i < this.settings.daysToShow.length; i++) {
      //   let itemIndex = this.settings.daysToShow[i];
      //   let day = this.days[itemIndex];
      //   tmpDaysToShow.push(day.id);
      // }
      // this.settings.daysToShow = tmpDaysToShow;
      return this.settings;
    },

    visibleDaysChanged() {
      console.log("days", this.settings.daysToShow);
      // this.saveSettings();
    },
    visibleDaysSelect() {
      console.log("days", this.settings.daysToShow);
    },
    // loadSettings() {
    //   let jsonSettings = localStorage.getItem("uisettings");
    //   let tmpSettings;
    //   if (jsonSettings !== null) {
    //     tmpSettings = JSON.parse(jsonSettings);
    //   }
    //   for(let i in this.settings){
    //       if(tmpSettings[i]==undefined)
    //         tmpSettings[i]=this.settings[i];
    //   }
    //   this.settings=tmpSettings;
    // },
    // saveSettings() {
    //   localStorage.setItem("uisettings", JSON.stringify(this.settings));
    // },
  },
  data() {
    return {
      PlannerMode:{...PlannerMode},
      settings: {},
      days: [
        { id: 1, text: "Lunedì" },
        { id: 2, text: "Martedì" },
        { id: 3, text: "Mercoledì" },
        { id: 4, text: "Giovedì" },
        { id: 5, text: "Venerdì" },
        { id: 6, text: "Sabato" },
        { id: 0, text: "Domenica" },
      ],
      createEventTabs: [
        { id: 1, text: "Data e ora", mandatory: true },
        { id: 2, text: "Operatori", mandatory: true },
        { id: 3, text: "Dati intervento", mandatory: true },
        { id: 4, text: "Cliente", mandatory: true },
        { id: 5, text: "Attrezzature", mandatory: false },
        { id: 6, text: "Mezzi", mandatory: false },
      ],
    };
  },
  components: {PlannerMode},
};

</script>
../../../settings/PlannerMode